










































































































































import Vue from 'vue';
import { ICheckoutLinks } from '@/common/interfaces/checkout.interface';
import Tooltip from '@/components/layout/popper/Tooltip.vue';
import TIcons from '@/types/TIcons';
import { IIcons } from '@/common/interfaces/index.interface';
import Overlay from '@/components/layout/Overlay.vue';
import CustomButton from '@/components/layout/buttons/CustomButton.vue';

interface ICheckoutCheckboxesComponent {
  icons: IIcons;
  links: ICheckoutLinks;
  locizeNamespace: string;
  paperInvoiceChecked: boolean;
  showOptInOverlay: boolean;
  partnerShipmentAuthorized: boolean;
  termsAndConditionsChecked: boolean;
  termsRetourChecked: boolean;
  tooltipOptions: {
    placement: string;
  };
}

export default Vue.extend({
  components: {
    CustomButton,
    Overlay,
    Tooltip,
  },
  data(): ICheckoutCheckboxesComponent {
    return {
      icons: TIcons,
      links: window.vueCheckoutLinks,
      locizeNamespace: `checkout:`,
      paperInvoiceChecked: !this.paperInvoiceWanted,
      partnerShipmentAuthorized: this.partnerShipmentAuthorizedPrechecked,
      showOptInOverlay: false,
      termsAndConditionsChecked: this.termsAndConditionsPrechecked,
      termsRetourChecked: this.termsRetourPrechecked,
      tooltipOptions: {
        placement: `bottom-end`,
      },
    };
  },
  props: {
    paperInvoiceWanted: {
      default: false,
      type: Boolean,
    },
    partnerShipmentAuthorizedPrechecked: {
      default: false,
      type: Boolean,
    },
    showPartnerAddressCheckbox: {
      default: false,
      type: Boolean,
    },
    termsAndConditionsPrechecked: {
      default: false,
      type: Boolean,
    },
    termsRetourPrechecked: {
      default: false,
      type: Boolean,
    },
    triedToSubmit: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    handlePaperInvoiceCheck(): void {
      this.showOptInOverlay = this.paperInvoiceChecked;
    },
  },
  watch: {
    paperInvoiceChecked: {
      handler(): void {
        this.$emit(`input:paper-invoice`, !this.paperInvoiceChecked);
      },
    },
    partnerShipmentAuthorized: {
      handler(): void {
        this.$emit(`input:partner-shipment-authorized`, this.partnerShipmentAuthorized);
      },
    },
    termsAndConditionsChecked: {
      handler(): void {
        this.$emit(`input:terms-and-conditions`, this.termsAndConditionsChecked);
      },
    },
    termsRetourChecked: {
      handler(): void {
        this.$emit(`input:terms-retour`, this.termsRetourChecked);
      },
    },
  },
});
